<ng-template #content let-c="close" let-d="dismiss">
    
    <div class="modal-header">
        <h6 class="modal-title">{{'TITLE.TITLE_TAG_STAFF' | translate}} <span *ngIf="JobData"> ({{JobData.DisplayCallNo}} | {{JobData.CallDescription}})</span></h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid">
        <form name="frm">
            <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>

            <div class="row form-group">
                <label class="col-auto col-form-label" translate>LBL.SEARCH</label>
                <div class="col-5"><input type="text" class="form-control" name="Keyword" [(ngModel)]="Keyword" (input)="onKeyword($event.target.value)" /> </div>
                <label class="col-3 col-form-label text-primary pointer font-weight-normal" translate (click)="SortData();">LBL.SELECTED_STAFF</label>
            </div>
        </form>
        <sk-wave [isRunning]="IsSubmitting"></sk-wave>
        <div class="grdTable tagStaff" *ngIf="!IsSubmitting">
            <div class="row no-gutters grdTableHeader">
                <div class="col-auto grdHead"></div>
                <div class="col-auto grdHead"></div>
                <div class="col-auto grdHead"><span translate>LBL.FRM_NAME</span></div>
                <div class="col-auto grdHead"><span translate>LBL.DEPARTMENT</span></div>
                <div class="col-auto grdHead"><span translate>LBL.DESIGNATION</span></div>
            </div>
            <div class="grdBodyScroll-Virtual" #scrollingBlock>
                <virtual-scroller #scroll [items]="Model" style="height:100%" [parentScroll]="scrollingBlock.nativeElement" id="virtualScroll">
                    <div *ngFor="let row of scroll.viewPortItems" class="row no-gutters grdRow">
                        <div class="col-auto grdCol"><input type="checkbox" name="chk_{{row.StaffId}}" id="chk_{{row.StaffId}}" class="" [(ngModel)]="row.Selected" (change)="onTagChange(row)" /></div>
                        <div class="col-auto grdCol"><div [class]="row.IsLoggedIn ? 'text-success': ''"><i class="fas fa-user fa-fw"></i></div></div>
                        <div class="col-auto grdCol">{{row.Description}}</div>
                        <div class="col-auto grdCol">{{masterService.MasterData_GetMutli(row.PropertId, row.DeptId, _EntityCodes.Department, row.Department)}}</div>
                        <div class="col grdCol">{{masterService.MasterData_GetMutli(row.PropertId, row.DesgId, _EntityCodes.Designation, row.Designation)}}</div>
                    </div>
                </virtual-scroller>

            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="onSubmit()" [disabled]="IsSubmitting" translate>BTN.BTN_SAVE</button>
        <button class="btn btn-secondary" type="button" (click)="c('')" translate>BTN.BTN_CANCEL</button>
    </div>
</ng-template>

<StaffJobList #staffJobList></StaffJobList>
